/**
 * Where the API is.
 *
 * Same origin by default, written out in full rather than left as a relative path: the client builds a
 * `Request`, and a `Request` wants an absolute URL. A browser would resolve a relative one against the
 * document, but nothing else that runs this code does — so it is resolved here, once, where it is obvious
 * what it resolved to.
 *
 * `VITE_API_BASE_URL` is unset in the browser — the API is served from the same origin behind IIS
 * (`ARCH-001 §2`) — and absolute in tooling that runs the two apart.
 *
 * It is its own module so that the refresh call and the typed client can both use it without importing
 * each other: the client retries through refresh, and refresh must not go back through the client.
 */
export function apiBaseUrl(): string {
  const configured = import.meta.env['VITE_API_BASE_URL'];
  if (configured) {
    return configured;
  }

  return typeof window === 'undefined' ? '' : window.location.origin;
}
